const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('ref')) {
  const ref = urlParams.get('ref');
  if (typeof Storage !== 'undefined') {
    window.localStorage.setItem('ref', ref);
  } else {
    const now = new Date();
    const timeToAdd = 1000 * 60 * 60 * 24 * 7 * 4 * 12; // 12 months
    now.setTime(now.getTime() + timeToAdd);
    document.cookie = `ref=${ref};expires=${now.toUTCString()};path=/`;
  }
}
